import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const AdminRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null means checking
    const location = useLocation();

    useEffect(() => {
        const verifySession = async () => {
            const token = sessionStorage.getItem('adminToken');
            if (!token) {
                setIsAuthenticated(false);
                return;
            }

            try {
                const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
                const res = await fetch(`${apiUrl}/api/admin/verify-session`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (res.ok) {
                    setIsAuthenticated(true);
                } else {
                    // Token invalid or expired, clear it
                    sessionStorage.removeItem('adminToken');
                    setIsAuthenticated(false);
                }
            } catch (err) {
                console.error("Session verification failed", err);
                setIsAuthenticated(false);
            }
        };

        verifySession();
    }, [location.pathname]); // re-verify on route change

    if (isAuthenticated === null) {
        return (
            <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
                <div className="text-gray-500 font-light tracking-[0.2em] animate-pulse">VERIFYING ACCESS...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }

    return children;
};
